import { render, staticRenderFns } from "./FormulateOskText.vue?vue&type=template&id=61eb820b&"
import script from "./FormulateOskText.vue?vue&type=script&lang=js&"
export * from "./FormulateOskText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61eb820b')) {
      api.createRecord('61eb820b', component.options)
    } else {
      api.reload('61eb820b', component.options)
    }
    module.hot.accept("./FormulateOskText.vue?vue&type=template&id=61eb820b&", function () {
      api.rerender('61eb820b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/formulate/on-screen-keyboard/osk-text/FormulateOskText.vue"
export default component.exports